import React from 'react';
// import __ from 'lodash';
 
class DropdownKota extends React.Component {
    render() {
        return (
            this.props.kota.map(val =>
                <option key={val.ID_KABUPATEN_KOTA} value={val.ID_KABUPATEN_KOTA}>{val.NAMA_KABUPATEN_KOTA}</option>
            )
        )
    }
}

export default DropdownKota;